export class TabbedCardListModule {

    constructor() {

        if ($(".tabbed-card-list").length > 0) {
            this.init();
        }
    }

    setupClicks() {
        $(".tabbed-card-list .dash-tabs>li>a").on("click", function (e) {
            e.preventDefault();

            if ($(this).parent().hasClass("active-tab")) {
                console.log("Aborting call");
                return;
            }

            $(".tabbed-card-list .tabs-panel .dash-tabs li.active-tab a").removeClass("button--teal-rounded");
            $(".tabbed-card-list .tabs-panel .dash-tabs li.active-tab a").addClass("button--grey-rounded");
            $(".tabbed-card-list .tabs-panel .dash-tabs li.active-tab").removeClass('active-tab');

            $(this).removeClass("button--grey-rounded");
            $(this).addClass("button--teal-rounded");
            $(this).parent().addClass("active-tab");

            let panelToShow = $(this).attr("rel");

            $(".tab-panel.active-tab-panel").removeClass("active-tab-panel");
            let panelToShowId = "#" + panelToShow;

            $(panelToShowId).addClass("active-tab-panel");
        });

        

    }

    init() {
        this.setupClicks();
    }

    process() {
        return undefined;
    }

}






